<template>
  <div class="home-page" data-cy="home-page">
    <!-- Cover edge case where user has only INGREDIENT role (No access to Home page) -->
    <AccessHandler
      :redirect="Pages.IarSubmissions"
      :requiredRoleGroups="roleGroups"
      @accessChanged="(a: boolean) => (hasAccess = a)"
    />
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <div class="home-page__container">
          <HomeView />
        </div>
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import HomeView from "./HomeView.vue";
import GlobalFooter from "../GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import type { RoleGroup } from "@/shared/access/RoleGroups";
import { useMainStore } from "@/stores/useMainStore";
import { UserRoles } from "@/Domain/UserRoles";
import { Pages } from "@/pages/pages";
import { ref } from "vue";

const main = useMainStore();
const hasAccess = ref<boolean>(false);

const roleGroups = [
  {
    validateRestrictionsAsync: async () => {
      return (
        main.roles?.length != 1 || main.roles[0] != UserRoles.ROLE_INGREDIENT
      );
    },
  },
] as RoleGroup[];
</script>

<style scoped lang="scss">
.home-page {
  &__container {
    margin: 40px 0;
    min-height: calc(100vh - 235px);
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
